export default "__VITE_ASSET__CT_$cWTs__"